import { render } from "./date-time.vue?vue&type=template&id=c5df1fe2&scoped=true"
import script from "./date-time.vue?vue&type=script&lang=js"
export * from "./date-time.vue?vue&type=script&lang=js"

import "./date-time.vue?vue&type=style&index=0&id=c5df1fe2&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5df1fe2"]])

export default __exports__